import Icon from './Icon'
import styled from 'styled-components'

export const StyledIcon = styled(Icon)`
  font-size: 2em;
`
